/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { StoreOrderVariance } from './StoreOrderVariance';
// @ts-ignore
import {
// @ts-ignore
    StoreOrderVarianceFromJSON,
// @ts-ignore
    StoreOrderVarianceFromJSONTyped,
// @ts-ignore
    StoreOrderVarianceToJSON,
} from './StoreOrderVariance';

/**
 * 
 * @export
 * @interface StoreOrderVarianceListResponse
 */
export interface StoreOrderVarianceListResponse {
    /**
     * 
     * @type {number}
     * @memberof StoreOrderVarianceListResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreOrderVarianceListResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {Array<StoreOrderVariance>}
     * @memberof StoreOrderVarianceListResponse
     */
    items: Array<StoreOrderVariance>;
}

/**
 * Check if a given object implements the StoreOrderVarianceListResponse interface.
 */
// @ts-ignore
export function instanceOfStoreOrderVarianceListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function StoreOrderVarianceListResponseFromJSON(json: any): StoreOrderVarianceListResponse {
    return StoreOrderVarianceListResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function StoreOrderVarianceListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreOrderVarianceListResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'items': ((json['items'] as Array<any>).map(StoreOrderVarianceFromJSON)),
    };
}

// @ts-ignore
export function StoreOrderVarianceListResponseToJSON(value?: StoreOrderVarianceListResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'items': ((value.items as Array<any>).map(StoreOrderVarianceToJSON)),
    };
}

